import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initRotateAnimations() {
    const rotateElements = document.querySelectorAll('[data-rotate-in]');
    
    rotateElements.forEach((element) => {
        const targetRotation = parseFloat(element.dataset.rotateIn) || -12;
        const duration = parseFloat(element.dataset.duration) || 1;
        const origin = element.dataset.origin || 'bottom left';
        
        gsap.set(element, { 
            rotation: 0, 
            opacity: 0,
            transformOrigin: origin
        });
        
        ScrollTrigger.create({
            trigger: element,
            start: "top 80%",
            end: "bottom 20%",
            onEnter: () => {
                gsap.to(element, {
                    rotation: targetRotation,
                    opacity: 1,
                    duration: duration,
                    ease: "power2.out"
                });
            },
            onLeave: () => {
                gsap.to(element, {
                    rotation: 0,
                    opacity: 0,
                    duration: duration,
                    ease: "power2.out"
                });
            },
            onEnterBack: () => {
                gsap.to(element, {
                    rotation: targetRotation,
                    opacity: 1,
                    duration: duration,
                    ease: "power2.out"
                });
            },
            onLeaveBack: () => {
                gsap.to(element, {
                    rotation: 0,
                    opacity: 0,
                    duration: duration,
                    ease: "power2.out"
                });
            }
        });
    });
}
